<template>
  <div class="uk-grid uk-child-width-1-1" data-uk-grid>
    <div>
      <div class="uk-flex uk-flex-between uk-flex-middle">
        <div>
          <h1 class="uk-h4 uk-margin-remove">
            <span data-uk-icon="icon: file-pdf; ratio:1.2"></span>
            Angebote
          </h1>
        </div>
        <div>
          <a @click.prevent="$router.go(-1)" class="uk-button uk-button-small uk-button-secondary">
            <span class="uk-margin-small-right uk-icon" uk-icon="icon: arrow-left"></span>
            Zurück
          </a>
        </div>
      </div>
    </div>
    <div v-if="offers.length && !loading">
      <offer-list-admin :offers="offers"></offer-list-admin>
    </div>
  </div>
</template>
<script>
import OfferService from '@/services/offer.service'
import OfferListAdmin from '@/components/offer/OfferListAdmin'
export default {
  data() {
    return {
      offers: [],
      loading: true
    }
  },
  components: {
    OfferListAdmin
  },
  mounted() {
    this.getSales()
  },
  methods: {
    async getSales() {
      const offers = await OfferService.getAll()
      this.offers = offers.data
      this.loading = false
    }
  }
}
</script>
